import { Modal, Form, Input, Button, Col, Row, notification} from 'antd';
import 'dayjs/locale/es-mx';
import store from '../../../../../controllers/store';
import { useSelector } from 'react-redux';
import { update } from '../../../../../controllers/store/actions/commonsCapacities/update-commonsCapacities-actions';
import SelectKnowledgeArea from '../../Elements/Select-Knowledge-Area';
import SelectKnowledgeSpecialty from '../../Elements/Select-Knowledge-Specialty';
import SelectKnowledgeGran from '../../Elements/Select-Knowledge-Gran';
import { useEffect } from 'react';

interface Props {
    loading?: boolean,
    visible: boolean,
    commonsCapacities : any,
    capacityType: any,
    onUpdated : ()=>void,
    onCancel: () => void,
}

const dispatch = store.dispatch;
const UpdateCommonsCapacitiesModal = (Props: Props) => {
    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();
    const updatedCommonsCapacitiesState = useSelector((state: any) => state.updatedCommonsCapacities);
    
    useEffect(() => {
        if (Props.commonsCapacities) {
            form.setFieldsValue({
                ...Props.commonsCapacities,
                area_de_conocimiento: { value: Props.commonsCapacities.area_de_conocimiento },
                especialidad_de_conocimiento: { value: Props.commonsCapacities.especialidad_de_conocimiento },
                gran_area_de_conocimiento: { value: Props.commonsCapacities.gran_area_de_conocimiento },
            });
        }
    }, [form, Props.commonsCapacities]);

    return (
        <Modal
            width={800}
            open={Props.visible}
            title={'Capacidad'}
            okText={'Actualizar'}
            cancelText="Cancelar"
            footer={null}
            onCancel={Props.onCancel}
        >
            <>
                {contextHolder}
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={async (formData: any) => {
                        form.validateFields().then(async (values: any) => {
                            await dispatch(update(Props.commonsCapacities.id, {
                                area_de_conocimiento: values.area_de_conocimiento.value,
                                beneficiario: values.beneficiario,
                                beneficios_que_genera: values.beneficios_que_genera,
                                capacity_type: Props.capacityType,
                                caracteristicas_de_productos_yo_servicios_que_genera: values.caracteristicas_de_productos_yo_servicios_que_genera,
                                nombre: values.nombre,
                                descripcion: values.descripcion,
                                descripcion_detallada: values.descripcion_detallada,
                                problemas_que_soluciona: values.problemas_que_soluciona,
                                grado_de_madurez_de_la_solucion_capacidad: values.grado_de_madurez_de_la_solucion_capacidad,
                                external_code: values.external_code,
                                identidad: values.identidad,
                                presupuesto: values.presupuesto,
                                gran_area_de_conocimiento: values.gran_area_de_conocimiento?.value,
                                especialidad_de_conocimiento: values.especialidad_de_conocimiento?.value
                            }));

                            Props.onUpdated();
                        });
                    }}
                    name="updateCommonscapacities"
                >
                    <Row gutter={[8, 8]} style={{ width: '100%', marginTop: 30 }}>
                        <Col xs={24} sm={12} md={8} lg={18}>
                            <Form.Item
                                label="Nombre"
                                name="nombre"
                                rules={[
                                    { required: true, message: 'Por favor ingrese el nombre de la capacidad' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Form.Item
                                label="Código"
                                name="external_code"
                                rules={[
                                    { type: 'string' }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Descripción"
                                name="descripcion"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input.TextArea />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Descripción detallada"
                                name="descripcion_detallada"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input.TextArea />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Area general"
                                name="area_de_conocimiento"
                                rules={[
                                    { type: 'object', required: true, message: "El campo es obligatorio" },
                                ]}
                            >
                                <SelectKnowledgeArea
                                    onClear={() => { }}
                                    style={{ width: '100%' }} size="large"
                                    onChange={(value) => form.setFieldsValue({ area_de_conocimiento: value })} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Área específica"
                                name="especialidad_de_conocimiento"
                                rules={[
                                    { type: 'object', required: true, message: "El campo es obligatorio" },
                                ]}
                            >
                                <SelectKnowledgeSpecialty
                                    onClear={() => { }}
                                    size="large"
                                    onChange={(value) => form.setFieldsValue({ especialidad_de_conocimiento: value })} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Gran área del conocimiento"
                                name="gran_area_de_conocimiento"
                                rules={[
                                    { type: 'object', required: true, message: "El campo es obligatorio" },
                                ]}
                            >
                                <SelectKnowledgeGran
                                    onClear={() => { }}
                                    style={{ width: '100%' }}
                                    size="large"
                                    onChange={(value) => form.setFieldsValue({ gran_area_de_conocimiento: value })} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Problemas que soluciona"
                                name="problemas_que_soluciona"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input.TextArea />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Beneficios que genera"
                                name="beneficios_que_genera"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input.TextArea />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Caracteristicas de productos y servicios que genera"
                                name="caracteristicas_de_productos_yo_servicios_que_genera"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input.TextArea />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Grado de madurez de la solución"
                                name="grado_de_madurez_de_la_solucion_capacidad"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input.TextArea />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Beneficiario"
                                name="beneficiario"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Identidad"
                                name="identidad"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Presupuesto"
                                name="presupuesto"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item wrapperCol={{ span: 24 }}>
                        <Button
                            loading={updatedCommonsCapacitiesState?.isLoading}
                            type="primary"
                            size={"large"}
                            block
                            htmlType="submit"
                        >
                            Actualizar Capacidad
                        </Button>
                    </Form.Item>
                </Form>
            </>
        </Modal>
    );
};

export default UpdateCommonsCapacitiesModal;
